import { useMutation, useQueryClient } from '@tanstack/react-query';

import { AddressApi } from '../api/addressApi';
import { NewOrderApi, OrderSubmitEntryError } from '../api/newOrderApi';
import {
  AddressFormFields,
  CreateOrderResponse,
  OrderViaAddressEntry,
} from '../types';

import { QUERY_KEY_ORDERS } from './useOrders';

export interface Params {
  orderViaAddressEntry: OrderViaAddressEntry;
  preParsedItems: AddressFormFields[];
}

export const useNewOrderSubmitEntry = () => {
  const queryClient = useQueryClient();

  return useMutation<
    CreateOrderResponse | undefined,
    OrderSubmitEntryError,
    Params
  >({
    mutationFn: async ({
      orderViaAddressEntry: addOrderWithItems,
      preParsedItems,
    }) => {
      const parsedAddresses = preParsedItems.map(
        async (enteredAddress: AddressFormFields) => {
          return await AddressApi.parseAddress(enteredAddress);
        },
      );

      const parsedAddressesResponse = await Promise.all(parsedAddresses || []);

      const body: OrderViaAddressEntry = {
        ...addOrderWithItems,
        items: parsedAddressesResponse,
      };

      const response = await NewOrderApi.newOrderSubmitEntry(body);
      return response?.data;
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_ORDERS],
      });
    },
  });
};
